import React, {useState,useContext} from 'react'
import {dataContext,localestr,uid,toText} from '../utils.js'
import EditCtrl from '../cmp/EditCtrl.js';


export default function CatModifiers({group,data,type=2,goodName,action}){
    const context=useContext(dataContext)
    const msg=context.msg
    const close_msg=context.clsTWnd
    const selUnitType=context.data['selUnitType']
    const catGoods=context.data['catGoods']
    const [tmpData, setTmpData] = useState(data||{})
    const setValue=(name,data)=>{
        const newData={uid:uid(),type,...tmpData}
        if(name==='good'){
            if(data.type&&parseInt(data.type)===0){
                msg(localestr('Товари з акцизними марками не можуть використовуватись\nв якості модифікаторів!'),localestr('Помилка'),[{caption:'OK',action:()=>{}}])
                return
            }
            //delete(data.big_img)
            //delete(data.small_img)
            data={id:data.id,name:data.name,parent:data.parent,type:data.type,unit:data.unit,sum_in:data.sum_in}
            if(!newData.name) newData.name=data.menu_name||data.name||''
        }
        newData[name]=data
        newData.edit=true
        setTmpData(newData)
    }
    
    const saveValue=()=>{
        if(!tmpData.name){
            msg(localestr('Необхідно заповнити назву!'),localestr('Помилка'),[{caption:'OK',action:()=>{}}])
            return
        }
        let name=tmpData.name
        tmpData.name=name.substring(0, 50)
        action(group,tmpData)
        close_msg()
    }

    let cost=null
    let unit=null
    if(tmpData.good){
        let sum_in=0
        if(!tmpData.good.sum_in){
            const itm=catGoods.find(el=>el.id===tmpData.good.id)
            if(itm) sum_in=itm.sum_in||0
        } else sum_in=tmpData.good.sum_in
        unit=<div style={{width:'120px',display:'inline-block',flexGrow:1,maxWidth:'260px',lineHeight:'24px',marginLeft:'4px'}}>{toText(tmpData.good.unit?selUnitType.find(x => x.value === tmpData.good.unit.value):'')}</div>
        const prc=sum_in*(parseFloat(tmpData.qtt||0))
        cost=<div><div style={{fontStyle:'italic'}}>{localestr('При продажу ')+goodName+localestr(' з даним модифікатором, буде списуватись ')+tmpData.good.name+'.'}</div>
        <div><div style={{fontStyle:'italic',display:'inline-block',width:'200px'}}>{localestr('Вартість модифікатора')}</div><div style={{fontWeight:'bold',display:'inline-block'}}>{prc.toFixed(2)}</div></div></div>
    }

    return(

        <div style={{display:'flex',flexDirection:'column', margin:'4px 0',minWidth:'337px',maxWidth:'640px'}}>
        <EditCtrl Capt={localestr('Назва')} Value={tmpData.name||null} typeVal={'text'} setVal={(d)=>{setValue('name',d)}} width1='50' width2='287'/>
        <EditCtrl Capt={localestr('Зміна ціни (+ або -)')} Value={tmpData.price||0} typeVal={'number'} setVal={(d)=>{setValue('price',d)}} width1='150' width2='187'/>
        <EditCtrl Capt={localestr('Списувати товар')} Value={tmpData.good||null} typeVal={'catGoods'} setVal={(d)=>{setValue('good',d)}} width1='125' width2='212'/>
        <div style={{margin:'2px 0',display:'inherit'}}>
        <EditCtrl Capt={localestr('в якій кількості')} Value={tmpData.qtt||0} typeVal={'number'} setVal={(d)=>{setValue('qtt',d)}} width1='125' width2='90'/>
        {unit}
        </div>
        {cost}
        <div className='no-print' style={{margin:'10px 0 0 0',minWidth:'337px',maxWidth:'674px',display:'flex',justifyContent:'center',flexGrow:'100000'}}>
        <div style={{width:'54px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={saveValue}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>OK</div></div>
        </div>
        </div>
    )
}
